export const SURVEY_ACTIVITY_LOG_MESSAGES = {
  manualProcessingToggled: 'MANUAL_PROCESSING_TOGGLED',
  confirmedHighCpi: 'CONFIRMED_HIGH_CPI',
  includeExcludeStatusToggled: 'INCLUDE_EXCLUDE_STATUS',
  includeExcludeListUploaded: 'INCLUDE_EXCLUDE_UPLOAD',
  includeExcludeListCleared: 'INCLUDE_EXCLUDE_CLEAR',
  scheduledLaunchToggled: 'SCHEDULED_LAUNCH_STATUS',
  scheduledPauseToggled: 'TOGGLED_SCHEDULED_PAUSE_UI',
  uniqueBuyerEntryLinksUpload: 'UNIQUE_BUYER_ENTRY_LINKS_UPLOAD',
  uniqueBuyerEntryLinksClear: 'UNIQUE_BUYER_ENTRY_LINKS_CLEAR',
} as const;

export type SurveyActivityLogMessage =
  (typeof SURVEY_ACTIVITY_LOG_MESSAGES)[keyof typeof SURVEY_ACTIVITY_LOG_MESSAGES];

export const SURVEY_LAUNCH_EDIT_ACTIVITY_LOG_CATEGORY = 'Survey_Launch_Edit';
